<div class="manage-users-container">
  <nav>
    <zbp-button-component
      (clickHandler)="goBack()"
      [iconName]="zbpIconNames.backArrow"
      theme="blackText"
      label="Back To Overview"
      [role]="'link'">
    </zbp-button-component>
  </nav>

  <header>
    <h1>{{ pageTitle }}</h1>
  </header>

  @if (form) {
    <form id="searchUsers" class="menus-actions" (ngSubmit)="search()" [formGroup]="form">
      @if (hasSchoolSelector) {
        <div class="school-dropdown">
          <label for="schoolSelector" class="form-label fw-bold">Select School</label>
          <zbp-select
            labelForId="schoolSelector"
            [items]="schools"
            bindLabel="name"
            bindValue="schoolId"
            [formControl]="$any(form.controls.schoolId)"
            [searchable]="false"
            [clearable]="false"
            [matchOptionWidth]="true" />
        </div>
      }
      <div class="bottom-section">
        <nav class="left-section">
          <ul>
            <li class="text-uppercase">
              <a
                [routerLink]="['./teachers']"
                role="button"
                [queryParams]="{ page: 1 }"
                [class.active-nav-link]="isManagingTeachers"
                queryParamsHandling="merge">
                Teachers
              </a>
            </li>
            <li class="text-uppercase">
              <a
                [routerLink]="['./admins']"
                role="button"
                [queryParams]="{ page: 1 }"
                [class.active-nav-link]="isManagingAdmins"
                queryParamsHandling="merge">
                Admins
              </a>
            </li>
            @if (showAllColumns) {
              <li class="text-uppercase">
                <a
                  [routerLink]="['./students']"
                  role="button"
                  [queryParams]="{ page: 1 }"
                  [class.active-nav-link]="isManagingStudents"
                  queryParamsHandling="merge">
                  Students
                </a>
              </li>
              <li class="text-uppercase">
                <a
                  [routerLink]="['./parents']"
                  role="button"
                  [queryParams]="{ page: 1 }"
                  [class.active-nav-link]="isManagingParents"
                  queryParamsHandling="merge">
                  Parents
                </a>
              </li>
            }
          </ul>
        </nav>
        <div class="right-section">
          <ul class="user-actions">
            <li>
              <zbp-button-component
                label="Add Users"
                theme="primaryText"
                [role]="'link'"
                [disabled]="!hasSchoolIdSet || districtWideSelected || (isOneRoster && !isManagingParents)"
                [ngbTooltip]="addUsersTooltipText ? addUsersTooltip : ''"
                (clickHandler)="openNewUser()">
              </zbp-button-component>
            </li>
            @if (!isOneRoster) {
              <li>
                <zbp-button-component
                  label="Import Users"
                  theme="primaryText"
                  [role]="'link'"
                  [disabled]="!hasSchoolIdSet || districtWideSelected"
                  [ngbTooltip]="importUsersTooltipText ? importUsersTooltip : ''"
                  #importTooltip="ngbTooltip"
                  (clickHandler)="importUsers(importTooltip)">
                </zbp-button-component>
              </li>
            }
            <li>
              <zbp-button-component
                label="Export Users"
                ariaLabel="Export Users"
                theme="primaryText"
                [disabled]="(!hasSchoolIdSet && !districtWideSelected) || showExportSpinner"
                [ngbTooltip]="exportUsersTooltipText ? exportUsersTooltip : ''"
                (clickHandler)="export()"
                [showSpinner]="showExportSpinner"
                >
              </zbp-button-component>
            </li>
            @if (isManagingStudent) {
              <li
                class="set-password-icon"
                placement="top-right">
                <zbp-button-component
                  [ngbTooltip]="studentPasswordsTooltip"
                  ariaLabel="Set student passwords"
                  [disabled]="!hasSchoolIdSet || districtWideSelected"
                  [iconName]="iconNames.key_horizontal"
                  theme="icon"
                  (click)="openCreateAllStudentsPasswordModal()">
                </zbp-button-component>
              </li>
            }
            <li class="delete-icon"
              [ngbTooltip]="deleteAllTooltip"
              placement="top-right">
              <zbp-button-component
                ariaLabel="Delete users"
                [disabled]="!hasSchoolIdSet || districtWideSelected || isOneRoster"
                [iconName]="iconNames.delete_all"
                theme="icon"
                (click)="deleteAll()">
              </zbp-button-component>
            </li>
            <ng-template #addUsersTooltip >
              <span>{{addUsersTooltipText}}</span>
            </ng-template>
            <ng-template #importUsersTooltip >
              <span>{{importUsersTooltipText}}</span>
            </ng-template>
            <ng-template #exportUsersTooltip >
              <span>{{exportUsersTooltipText}}</span>
            </ng-template>
            <ng-template #studentPasswordsTooltip >
              <span>{{changeAllStudentsPasswordText}}</span>
            </ng-template>
            <ng-template #deleteAllTooltip >
              <span>{{deleteAllUsersTooltipText}}</span>
            </ng-template>
          </ul>
          <div class="search-section">
            <zbp-text-search
              [searchTermPlaceholderText]="'Search Users'"
              formControlName="userSearchCriteria"
              (searchFunc)="search()"
              >
            </zbp-text-search>
          </div>
        </div>
      </div>
    </form>
  }
  <zbp-branded-fallback-download
    #exportDownload
    class="w-50 d-block ms-auto text-end"
    [attr.aria-hidden]="!isExporting">
  </zbp-branded-fallback-download>
  @if (school) {
    <section #schoolsSection class="w-100">
      <router-outlet></router-outlet>
    </section>
  } @else {
    <aside id="manageUserErrorContainer" class="text-center alert alert-danger w-100 mt-4">
      There are no schools in this district yet. A school must be added to the district before users can be added.
    </aside>
  }
</div>
